'use client';

import { SearchInput } from '@/components/ui/SearchInput';
import { Grid } from '@/components/ui/Grid';

export default function HomePage() {
  const handleSearch = (query: string) => {
    // The SearchInput component now handles the navigation directly,
    // but we can still add additional logic here if needed
    console.log('Search:', query);
  };

  return (
    <>
      <Grid className="opacity-60" />

      <div className="container relative flex h-[calc(100vh-10rem)] flex-col items-center justify-center mx-auto pb-10">
        {/* Adjust h- calculation based on header/footer height if needed */}
        <div className="flex w-full max-w-[650px] flex-col justify-center space-y-6 sm:space-y-10 px-4 mx-auto">
          <div className="flex flex-col items-center space-y-4 sm:space-y-6 text-center">
            <div className="relative">
              <div className="flex flex-row items-center justify-center gap-4">
                <h1 className="text-4xl sm:text-6xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-b from-foreground to-foreground/70">
                  Sparkscan
                </h1>
              </div>
              <div className="absolute -inset-6 -z-10 blur-lg opacity-30 bg-primary/20 rounded-full" />
            </div>
            <p className="text-base sm:text-xl text-muted-foreground max-w-[90%] sm:max-w-full mt-[-3px]">
              Explore Spark balances, tokens, and transactions.
            </p>
          </div>
          <div className="w-full mt-[-13px]">
            <SearchInput
              placeholder="Search for anything..."
              onSearch={handleSearch}
              className="text-base sm:text-xl"
            />
          </div>
        </div>
      </div>
    </>
  );
}
